var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.001,
    height: 32,
    viewBox: "0 0 32.001 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,4.784a5.292,5.292,0,1,1-5.292,5.292A5.293,5.293,0,0,1,16,4.785Zm0,23.033A11.743,11.743,0,0,1,8.35,25a2.255,2.255,0,0,1-.791-1.714,5.337,5.337,0,0,1,5.363-5.336h6.158a5.33,5.33,0,0,1,5.355,5.336A2.25,2.25,0,0,1,23.645,25,11.739,11.739,0,0,1,16,27.818Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserWhite);
export default __webpack_public_path__ + "static/media/profile-userWhite.ece19e7031b33774bda957f362a3845f.svg";
export { ForwardRef as ReactComponent };